import { useAppDispatch } from '../hooks/redux-hooks'
import { SyntheticEvent, useState } from 'react'
import { Roles, postAuth } from 'api/reader-api'
import { useLocation, useNavigate } from 'react-router-dom'
import { setUser } from 'store/slices/userSlice'
import { toast } from 'react-toastify'

const Login = () => {
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault()

    postAuth(name, password)
      .then((response) => {
        if (
          response.token &&
          response.expires_at &&
          response.expires_in &&
          response.expires_in > 0 &&
          !response.roles.includes(Roles.Reader)
        ) {
          dispatch(
            setUser({
              token: response.token,
              roles: response.roles,
              expires_in: response.expires_in,
              expires_at: response.expires_at,
            })
          )
          const from = location.state?.from || '/'
          navigate(from)
        } else {
          toast.error('Invalid name or password')
        }
      })
      .catch((error: Error) => {
        toast.error(error.message)
      })
  }

  return (
    <div className='min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 px-6'>
      <div className='mt-8 sm:mx-auto sm:w-full sm:max-w-md'>
        <div className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'>
          <form onSubmit={handleSubmit} className='space-y-6'>
            <div>
              <label
                htmlFor='name'
                className='block text-sm font-medium leading-5  text-gray-700'
              >
                Name
              </label>
              <div className='mt-1 relative rounded-md shadow-sm'>
                <input
                  id='name'
                  name='name'
                  type='text'
                  className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className='mt-6'>
                <label
                  htmlFor='password'
                  className='block text-sm font-medium leading-5 text-gray-700'
                >
                  Password
                </label>
                <div className='mt-1 rounded-md shadow-sm'>
                  <input
                    id='password'
                    name='password'
                    type='password'
                    className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className='mt-6'>
              <span className='block w-full rounded-md shadow-sm'>
                <button
                  type='submit'
                  className='w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out'
                >
                  Login
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export { Login }
